import * as React from "react";
import {AsyncAjax, PromiseToken} from "../../../Shared/AsyncAjax";
import {ListGroup, ListGroupItem} from "react-bootstrap";
import {PlayerItem} from "./PlayerItem";
import 'jQuery';
import "es6-promise";
declare var smartformsrecordingparams:any;


export class PlayerItemList  extends React.Component<PlayerItemListProps,PlayerItemListState>{
    public LastItem:any=null;
    private executinSearch:boolean=false;
    private currentPage=-1;
    private items:PlayerHeader[]=[];
    private noMoreRecords:boolean=false;
    private ExecutinSearchToken:PromiseToken;
    constructor(){
        super();
        this.state={
            HeaderItems:[],
            SelectedItem:null
        };



    }

    ItemSelected(header:PlayerHeader):void{
        this.setState({SelectedItem:header});
        this.props.ItemSelected(header);
    }

    render(){
        return (
            <ListGroup>
            {this.state.HeaderItems.map((headerItems,index)=>{return (
                <PlayerItem item={headerItems}  key={headerItems==null?null:headerItems.uniq_id} onClick={()=>this.ItemSelected(headerItems)} className={headerItems!=null&&headerItems==this.state.SelectedItem?"active":""} >

                </PlayerItem>
            )})}
                {this.noMoreRecords?
                    (
                        this.state.HeaderItems==null||this.state.HeaderItems.length==0?
                            <a  style={{padding:'20px', backgroundColor:'#eee'}} className="list-group-item"><span className="glyphicon glyphicon-exclamation-sign"></span> Oh there are no recordings to show, please wait until someone use your site and try again</a>
                            :<a  style={{padding:'20px', backgroundColor:'#eee'}} className="list-group-item"><span className="glyphicon glyphicon-road"></span> End of the road, there are no more recordings!</a>
                    ):<PlayerItem item={null} ref={(list=>this.LastItem=list)} onClick={()=>this.ItemSelected(null)}  className=''/>
                }
        </ListGroup>);
    }


    componentDidMount() {
        jQuery(window).scroll(()=>{
            this.CheckIfLoadingIsNeedes();
        });
        this.ExecuteSearch();
    }

    public Refresh(){
        this.noMoreRecords=false;
        this.currentPage=-1;
        if(this.ExecutinSearchToken!=null) {
            this.ExecutinSearchToken.Cancel();
            this.ExecutinSearchToken=null;
        }
        this.setState({HeaderItems:[],SelectedItem:null});
        this.ExecuteSearch();
    }

    public async ExecuteSearch(){
        if(!this.executinSearch)
        {
            this.executinSearch=true;
            let promiseWithToken=AsyncAjax.PostWithToken<PlayerHeader[]>({action:'rednao_ssr_get_recordings',page:++this.currentPage});
            this.ExecutinSearchToken=promiseWithToken.Token;
            let resultWithToken=await promiseWithToken.Promise;
            if(resultWithToken.WasCancelled) {
                this.executinSearch=false;
                return;
            }
            this.ExecutinSearchToken=null;
            let result=resultWithToken.Result;
            if(result.length==0||result.length<20)
                this.noMoreRecords=true;
            this.setState({HeaderItems:this.state.HeaderItems.concat(result)});
            this.executinSearch=false;
        }
    }

    private CheckIfLoadingIsNeedes() {
        if(this.LastItem==null)
            return;
        let scrollTop=jQuery(window).scrollTop();
        let windowHeight=jQuery(window).height();

        let lastNodeTop=this.LastItem.$Container.offset().top;

        if(lastNodeTop-200<scrollTop+windowHeight)
            this.ExecuteSearch();
    }


    componentDidUpdate(prevProps: Readonly<PlayerItemListProps>, prevState: Readonly<PlayerItemListState>, prevContext: any): void {
        if(this.props.SelectedItem!=prevProps.SelectedItem&&this.props.SelectedItem!=this.state.SelectedItem)
            this.setState({SelectedItem:this.props.SelectedItem});
    }
}


//<editor-fold desc="DTO">
interface PlayerItemListState{
    HeaderItems:PlayerHeader[];
    SelectedItem:PlayerHeader;

}

interface PlayerItemListProps{
    ItemSelected:(item:PlayerHeader)=>void,
    SelectedItem:PlayerHeader;
}

export interface PlayerHeader{
    duration:string;
    start_time:string;
    uniq_id:string;
    url:string;
}
//<editor-fold>


// WEBPACK FOOTER //
// ./React/Screens/Player/PlayerItemList.tsx